/**
 * Dependencies.
 */
import { BaseModel, endpoint, prop } from '@prz-dp/services';

/**
 * Model `AddressSearchModel`.
 */
@endpoint('address/search')
export default class AddressSearchModel extends BaseModel {
  /**
   * Properties.
   */
  @prop()
  addresses: {
    additionalInformation?: string;
    city?: string;
    countryCode?: string;
    countryName?: string;
    doorNumber?: number;
    latitude?: number;
    longitude?: number;
    street?: string;
    zipCode?: string;
  }[];

  @prop()
  isValidated?: boolean;

  /**
   * Constructor.
   */
  constructor(data: Partial<AddressSearchModel>) {
    super(data);
  }
}
